import { setJwt } from '@/api'
import { accountApi } from '@/api/account'
import { defineStore } from 'pinia'
import { computed, ref } from 'vue'
import { useRouter } from 'vue-router'
import { useProgramsStore } from './programs'

export const useAccountStore = defineStore("account", () => {

  const status = ref<"init" | "not-authorized" | "authorized">("init")
  const currentUser = ref<{ id: string, name: string, role: string, avatar: string, isDirector: boolean, isSupervisor: boolean } | null>(null)
  const router = useRouter()

  const authorizeUser = (user: typeof currentUser.value) => {
    currentUser.value = user
    status.value = "authorized"
  }

  const init = async () => {
    if ([ "fb", "auth" ].includes(router.currentRoute.value.name as string)) {
      status.value = "not-authorized"
      return
    }
    const token = window.localStorage.getItem("skolkovoToken")
    if (token) setJwt(token)
    try {
      const userInfo = await accountApi.getUserInfo()
      authorizeUser(userInfo)
    } catch(e) {
      status.value = "not-authorized"
      router.push("/auth")
    }
  }

  const login = async ({ login, password }: { login: string, password: string }) => {
    const resp = await accountApi.login({ login, password })
    window.localStorage.setItem("skolkovoToken", resp.token)
    setJwt(resp.token)
    authorizeUser(resp.user)
    router.push("/")
  }
  
  const logout = async () => {
    setJwt(null)
    status.value = "not-authorized"
    router.push("/auth")
    currentUser.value = null

    const programsStore = useProgramsStore()
    programsStore.programs.length = 0
    programsStore.status = "init"
  }

  const isDirector = computed(() => {
    return !!currentUser.value?.isDirector
  })

  const isSupervisor = computed(() => {
    return !!currentUser.value?.isSupervisor
  })

  return {
    status,
    currentUser,
    isDirector,
    isSupervisor,
    init,
    login,
    logout
  }

})